export default [
  {
    path: '/unsubscribe/digest/:type',
    name: 'Unsubscribe Digest',
    meta: {
      authRequired: false,
      guestPage: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        // hide freshchat
        const fcId = document.getElementById('custom_fc_button')
        if (fcId) {
          fcId.style = 'display: none'
        }
        next()
      },
    },
    component: () => import('@/router/views/unsubscribe/digest'),
  },
  {
    path: '/unsubscribe/digest/:type/result',
    name: 'Unsubscribe Digest Result',
    meta: {
      authRequired: false,
      guestPage: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        // hide freshchat
        const fcId = document.getElementById('custom_fc_button')
        if (fcId) {
          fcId.style = 'display: none'
        }
        next()
      },
    },
    component: () => import('@/router/views/unsubscribe/digest/ResultPage'),
  },
]
